'use client'
import React, { useEffect } from 'react'
import { useTranslation } from '@/localization/useTranslation'
import { Spinner } from '@/components/Loading/Spinner'
import { IRedirectScript, IRedirectScriptOptions } from './types'
import { navigateTo } from '@/utils/url'

import classes from './styles.module.scss'
interface RedirectActorProps {
  script: IRedirectScript
}

export const RedirectActor = (props: RedirectActorProps) => {
  const { script } = props
  const options: Partial<IRedirectScriptOptions> = script?.options ?? {}
  const { t } = useTranslation()

  useEffect(() => {
    if (!options.redirectTo) return

    navigateTo(options.redirectTo)
  }, [options?.redirectTo])

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <Spinner />
        <h1 className={classes.text}>
          {t(options.text || 'You\'re being redirected')}
        </h1>
      </div>
    </div>
  )
}
